/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export interface IGlobalLoaderConfig {}

export interface IGlobalLoaderProps<T> extends Msdyn365.IModule<T> {
    config: IGlobalLoaderConfig;
}

export interface IGlobalLoaderViewProps extends IGlobalLoaderProps<{}> {}

/**
 * Global Loader Module
 * Event-based loader that listens to globalloader:show/hide/update events
 * Add this module to any page where you need the global loader
 */
const GlobalLoader: React.FC<IGlobalLoaderProps<{}>> = props => {
    return props.renderView(props) as React.ReactElement;
};

export default GlobalLoader;
